import React, { useEffect } from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import Content from "../../Content"
import Header from "../../Header"

import { PRIVACY_POLICY_SECTIONS } from "../../constants"

export default ({
  page,
  openPrivacyPolicy,
}: {
  page: string
  openPrivacyPolicy: () => boolean | undefined
}) => {
  useEffect(() => {
    if (openPrivacyPolicy) openPrivacyPolicy()
  }, [])
  return (
    <div className="flex-column" data-testid="privacy-policy">
      <div>
        <Header />
        <Switch>
          {PRIVACY_POLICY_SECTIONS.map((el) => (
            <Route
              key={el}
              exact
              path={`${page}${el.split(" ").join("-").toLowerCase()}`}
            >
              <Content section={el.split("/").pop()} />
            </Route>
          ))}
          <Route path="*">
            <Redirect
              to={`${page}${PRIVACY_POLICY_SECTIONS[0]
                .split(" ")
                .join("-")
                .toLowerCase()}`}
            />
          </Route>
        </Switch>
      </div>
    </div>
  )
}
